import { action, observable } from 'mobx';

class SnackbarStore {
  @observable
  open: boolean = false;
  @observable
  message: string = 'Sending Email';

  private timeout?: number = -1;

  @action.bound
  onNotify(message: string | null, open: boolean | null) {
    if (open !== null) {
      if (!!this.timeout) {
        clearTimeout(this.timeout);
      }

      this.open = open;
      this.timeout = setTimeout(this.onClose, 3000);
    }

    if (message !== null) {
      this.message = message;
    }
  }

  @action.bound
  private onClose() {
    this.open = false;
    this.timeout = undefined;
  }
}

export default new SnackbarStore();
